import { ClientV2 } from "./baseurl";

// El texto lo escribe el usuario: sin encodear, caracteres como & # + % rompen
// el query string y la busqueda llega truncada al backend.
export const getResults = async(strToSearch:string, signal?: AbortSignal) => {
    const response = await ClientV2.get(`/item-search?itemTitle=${encodeURIComponent(strToSearch)}`, { signal });
    return response.data;
}
